import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: "cart",
  initialState: [],
  reducers: {
    aggiungiAlCarrello(state, action) {
      state.push(action.payload);
    },
    rimuoviDalCarrello(state, action) {
      state.splice(action.payload, 1);
    },
    azzeraCarrello(state) {
      state.splice(0, state.length);
    },
  },
});

export const { aggiungiAlCarrello, rimuoviDalCarrello, azzeraCarrello } =
  cartSlice.actions;
export default cartSlice.reducer;
